tinymce.addI18n("zh_SG", {
    "#": "#",
    "Accessibility": "\u5354\u52a9\u5de5\u5177",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "\u52d5\u4f5c",
    "Activity": "\u6d3b\u52d5",
    "Address": "\u5730\u5740",
    "Advanced": "\u9ad8\u7d1a",
    "Align": "\u5c0d\u9f4a",
    "Align center": "\u7f6e\u4e2d\u5c0d\u9f4a",
    "Align left": "\u5de6\u5c0d\u9f4a",
    "Align right": "\u53f3\u5c0d\u9f4a",
    "Alignment": "\u5c0d\u9f4a",
    "Alignment {0}": "",
    "All": "\u5168\u90e8",
    "Alternative description": "\u66ff\u4ee3\u63cf\u8ff0",
    "Alternative source": "\u93e1\u50cf",
    "Alternative source URL": "\u66ff\u4ee3\u4f86\u6e90\u7db2\u5740",
    "Anchor": "\u9328\u9ede",
    "Anchor...": "\u9328\u9ede...",
    "Anchors": "\u9328\u9ede",
    "Animals and Nature": "\u52d5\u7269\u548c\u81ea\u7136",
    "Arrows": "\u7bad\u982d",
    "B": "\u85cd",
    "Background color": "\u80cc\u666f\u984f\u8272",
    "Background color {0}": "",
    "Black": "\u9ed1\u8272",
    "Block": "\u584a",
    "Block {0}": "",
    "Blockquote": "\u5f15\u6587\u5340\u584a",
    "Blocks": "\u6a23\u5f0f",
    "Blue": "\u85cd\u8272",
    "Blue component": "\u767d\u8272\u90e8\u5206",
    "Body": "\u8868\u9ad4",
    "Bold": "\u7c97\u9ad4",
    "Border": "\u6846\u7dda",
    "Border color": "\u6846\u7dda\u984f\u8272",
    "Border style": "\u908a\u6846\u6a23\u5f0f",
    "Border width": "\u908a\u6846\u5bec\u5ea6",
    "Bottom": "\u4e0b\u65b9\u5c0d\u9f4a",
    "Browse files": "",
    "Browse for an image": "\u700f\u89bd\u5716\u50cf",
    "Browse links": "",
    "Bullet list": "\u7121\u5e8f\u5217\u8868",
    "Cancel": "\u53d6\u6d88",
    "Caption": "\u6a19\u984c",
    "Cell": "\u5132\u5b58\u683c",
    "Cell padding": "\u5132\u5b58\u683c\u5167\u908a\u8ddd",
    "Cell properties": "\u5132\u5b58\u683c\u5c6c\u6027",
    "Cell spacing": "\u5132\u5b58\u683c\u5916\u9593\u8ddd",
    "Cell styles": "\u5132\u5b58\u683c\u6a23\u5f0f",
    "Cell type": "\u5132\u5b58\u683c\u5225",
    "Center": "\u7f6e\u4e2d",
    "Characters": "\u5b57\u5143",
    "Characters (no spaces)": "\u5b57\u5143(\u7121\u7a7a\u683c)",
    "Circle": "\u7a7a\u5fc3\u5713",
    "Class": "\u985e\u578b",
    "Clear formatting": "\u6e05\u9664\u683c\u5f0f",
    "Close": "\u95dc\u9589",
    "Code": "\u4ee3\u78bc",
    "Code sample...": "\u793a\u7bc4\u4ee3\u78bc...",
    "Code view": "\u4ee3\u78bc\u8996\u5716",
    "Color Picker": "\u9078\u8272\u5668",
    "Color swatch": "\u984f\u8272\u6a23\u672c",
    "Cols": "\u5217",
    "Column": "\u6b04",
    "Column clipboard actions": "\u5217\u526a\u8cbc\u677f\u64cd\u4f5c",
    "Column group": "\u5217\u7d44",
    "Column header": "\u5217\u6a19\u984c",
    "Constrain proportions": "\u4fdd\u6301\u6bd4\u4f8b",
    "Copy": "\u8907\u88fd",
    "Copy column": "\u8907\u88fd\u5217",
    "Copy row": "\u8907\u88fd\u884c",
    "Could not find the specified string.": "\u672a\u627e\u5230\u641c\u7d22\u5167\u5bb9\u3002",
    "Could not load emojis": "\u7121\u6cd5\u8f09\u5165Emojis",
    "Count": "\u8a08\u6578",
    "Currency": "\u8ca8\u5e63",
    "Current window": "\u7576\u524d\u7a97\u53e3",
    "Custom color": "\u81ea\u8a02\u984f\u8272",
    "Custom...": "\u81ea\u8a02......",
    "Cut": "\u526a\u4e0b",
    "Cut column": "\u526a\u4e0b\u5217",
    "Cut row": "\u526a\u4e0b\u884c",
    "Dark Blue": "\u6df1\u85cd\u8272",
    "Dark Gray": "\u6df1\u7070\u8272",
    "Dark Green": "\u6df1\u7da0\u8272",
    "Dark Orange": "\u6df1\u6a59\u8272",
    "Dark Purple": "\u6df1\u7d2b\u8272",
    "Dark Red": "\u6df1\u7d05\u8272",
    "Dark Turquoise": "\u6df1\u85cd\u7da0\u8272",
    "Dark Yellow": "\u6697\u9ec3\u8272",
    "Dashed": "\u865b\u7dda",
    "Date/time": "\u65e5\u671f/\u6642\u9593",
    "Decrease indent": "\u6e1b\u5c11\u7e2e\u9032",
    "Default": "\u9810\u8a2d",
    "Delete accordion": "",
    "Delete column": "\u522a\u9664\u5217",
    "Delete row": "\u522a\u9664\u884c",
    "Delete table": "\u522a\u9664\u8868\u683c",
    "Dimensions": "\u5c3a\u5bf8",
    "Disc": "\u5be6\u5fc3\u5713",
    "Div": "DIV",
    "Document": "\u6587\u4ef6",
    "Dotted": "\u865b\u7dda",
    "Double": "\u96d9\u7cbe\u5ea6",
    "Drop an image here": "\u62d6\u653e\u4e00\u5f35\u5716\u50cf\u81f3\u6b64",
    "Dropped file type is not supported": "\u6b64\u6a94\u6848\u985e\u578b\u4e0d\u652f\u6301\u62d6\u653e",
    "Edit": "\u7de8\u8f2f",
    "Embed": "\u5167\u5d4c",
    "Emojis": "Emojis",
    "Emojis...": "Emojis...",
    "Error": "\u932f\u8aa4",
    "Error: Form submit field collision.": "\u932f\u8aa4\uff1a\u8868\u683c\u51fa\u73fe\u591a\u91cd\u63d0\u4ea4\u885d\u7a81\u3002",
    "Error: No form element found.": "\u932f\u8aa4\uff1a\u627e\u4e0d\u5230\u8868\u683c\u5143\u7d20\u3002",
    "Extended Latin": "\u62c9\u4e01\u8a9e\u64f4\u5145",
    "Failed to initialize plugin: {0}": "\u7121\u6cd5\u521d\u59cb\u5316\u63d2\u4ef6 {0}",
    "Failed to load plugin url: {0}": "\u7121\u6cd5\u8f09\u5165\u63d2\u4ef6\u93c8\u7d50 {0}",
    "Failed to load plugin: {0} from url {1}": "\u7121\u6cd5\u5f9e {1} \u8f09\u5165\u63d2\u4ef6 {0}",
    "Failed to upload image: {0}": "\u4e0a\u8f09\u5716\u7247\u5931\u6557\uff1a{0}",
    "File": "\u6587\u4ef6",
    "Find": "\u5c0b\u627e",
    "Find (if searchreplace plugin activated)": "\u5c0b\u627e(\u5982\u679c\u5c0b\u627e\u53d6\u4ee3\u5916\u639b\u7a0b\u5f0f\u5df2\u555f\u52d5)",
    "Find and Replace": "\u5c0b\u627e\u548c\u53d6\u4ee3",
    "Find and replace...": "\u5c0b\u627e\u4e26\u53d6\u4ee3...",
    "Find in selection": "\u5728\u9078\u5340\u4e2d\u5c0b\u627e",
    "Find whole words only": "\u5168\u5b57\u5339\u914d",
    "Flags": "\u65d7\u5e5f",
    "Focus to contextual toolbar": "\u79fb\u52d5\u7126\u9ede\u5230\u4e0a\u4e0b\u6587\u83dc\u55ae",
    "Focus to element path": "\u79fb\u52d5\u7126\u9ede\u5230\u5143\u7d20\u8def\u5f91",
    "Focus to menubar": "\u79fb\u52d5\u7126\u9ede\u5230\u529f\u80fd\u8868\u5217",
    "Focus to toolbar": "\u79fb\u52d5\u7126\u9ede\u5230\u5de5\u5177\u5217",
    "Font": "\u5b57\u9ad4",
    "Font size {0}": "",
    "Font sizes": "\u5b57\u9ad4\u5927\u5c0f",
    "Font {0}": "",
    "Fonts": "\u5b57\u9ad4",
    "Food and Drink": "\u98df\u7269\u548c\u98f2\u54c1",
    "Footer": "\u8868\u5c3e",
    "Format": "\u683c\u5f0f",
    "Format {0}": "",
    "Formats": "\u683c\u5f0f",
    "Fullscreen": "\u5168\u7192\u5e55",
    "G": "\u7da0",
    "General": "\u4e00\u822c",
    "Gray": "\u7070\u8272",
    "Green": "\u7da0\u8272",
    "Green component": "\u7da0\u8272\u90e8\u5206",
    "Groove": "\u51f9\u69fd",
    "Handy Shortcuts": "\u5feb\u901f\u9375",
    "Header": "\u8868\u982d",
    "Header cell": "\u8868\u982d\u5132\u5b58\u683c",
    "Heading 1": "\u4e00\u7d1a\u6a19\u984c",
    "Heading 2": "\u4e8c\u7d1a\u6a19\u984c",
    "Heading 3": "\u4e09\u7d1a\u6a19\u984c",
    "Heading 4": "\u56db\u7d1a\u6a19\u984c",
    "Heading 5": "\u4e94\u7d1a\u6a19\u984c",
    "Heading 6": "\u516d\u7d1a\u6a19\u984c",
    "Headings": "\u6a19\u984c",
    "Height": "\u9ad8\u5ea6",
    "Help": "\u5e6b\u52a9",
    "Hex color code": "\u5341\u516d\u9032\u4f4d\u984f\u8272\u4ee3\u78bc",
    "Hidden": "\u96b1\u85cf",
    "Horizontal align": "\u6c34\u6e96\u5c0d\u9f4a",
    "Horizontal line": "\u6c34\u6e96\u5206\u5272\u7dda",
    "Horizontal space": "\u6c34\u6e96\u9593\u8ddd",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID\u61c9\u8a72\u4ee5\u82f1\u6587\u5b57\u6bcd\u958b\u982d\uff0c\u5f8c\u9762\u53ea\u80fd\u6709\u82f1\u6587\u5b57\u6bcd\u3001\u6578\u4f4d\u3001\u7834\u6298\u865f\u3001\u9ede\u3001\u5192\u865f\u6216\u5e95\u7dda\u3002",
    "Image is decorative": "\u9019\u662f\u88dd\u98fe\u5716\u50cf",
    "Image list": "\u5716\u7247\u6e05\u55ae",
    "Image title": "\u5716\u7247\u6a19\u984c",
    "Image...": "\u5716\u7247...",
    "ImageProxy HTTP error: Could not find Image Proxy": "\u5716\u7247\u670d\u52d9\uff1a\u627e\u4e0d\u5230\u670d\u52d9",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "\u5716\u7247\u670d\u52d9\uff1a\u932f\u8aa4\u93c8\u7d50",
    "ImageProxy HTTP error: Rejected request": "\u5716\u7247\u670d\u52d9\uff1a\u62d2\u7d55\u5b58\u53d6",
    "ImageProxy HTTP error: Unknown ImageProxy error": "\u5716\u7247\u670d\u52d9\uff1a\u672a\u77e5\u932f\u8aa4",
    "Increase indent": "\u589e\u52a0\u7e2e\u9032",
    "Inline": "\u6587\u672c",
    "Insert": "\u63d2\u5165",
    "Insert Template": "\u63d2\u5165\u7bc4\u672c",
    "Insert accordion": "",
    "Insert column after": "\u5728\u53f3\u5074\u63d2\u5165\u5217",
    "Insert column before": "\u5728\u5de6\u5074\u63d2\u5165\u5217",
    "Insert date/time": "\u63d2\u5165\u65e5\u671f/\u6642\u9593",
    "Insert image": "\u63d2\u5165\u5716\u7247",
    "Insert link (if link plugin activated)": "\u63d2\u5165\u9023\u7d50 (\u5982\u679c\u9023\u7d50\u5916\u639b\u7a0b\u5f0f\u5df2\u555f\u52d5)",
    "Insert row after": "\u5728\u4e0b\u65b9\u63d2\u5165\u884c",
    "Insert row before": "\u5728\u4e0a\u65b9\u63d2\u5165\u884c",
    "Insert table": "\u63d2\u5165\u8868\u683c",
    "Insert template...": "\u63d2\u5165\u7bc4\u672c...",
    "Insert video": "\u63d2\u5165\u8996\u983b",
    "Insert/Edit code sample": "\u63d2\u5165/\u7de8\u8f2f\u4ee3\u78bc\u793a\u7bc4",
    "Insert/edit image": "\u63d2\u5165/\u7de8\u8f2f\u5716\u7247",
    "Insert/edit link": "\u63d2\u5165/\u7de8\u8f2f\u9023\u7d50",
    "Insert/edit media": "\u63d2\u5165/\u7de8\u8f2f\u5a92\u9ad4",
    "Insert/edit video": "\u63d2\u5165/\u7de8\u8f2f\u8996\u983b",
    "Inset": "\u5d4c\u5165",
    "Invalid hex color code: {0}": "\u7121\u6548\u7684\u984f\u8272\u78bc\uff1a{0}",
    "Invalid input": "\u7121\u6548\u8f38\u5165",
    "Italic": "\u659c\u9ad4",
    "Justify": "\u5169\u7aef\u5c0d\u9f4a",
    "Keyboard Navigation": "\u9375\u76e4\u6307\u5f15",
    "Language": "\u8a9e\u8a00",
    "Learn more...": "\u4e86\u89e3\u66f4\u591a...",
    "Left": "\u5de6",
    "Left to right": "\u7531\u5de6\u5230\u53f3",
    "Light Blue": "\u6dfa\u85cd\u8272",
    "Light Gray": "\u6dfa\u7070\u8272",
    "Light Green": "\u6dfa\u7da0\u8272",
    "Light Purple": "\u6dfa\u7d2b\u8272",
    "Light Red": "\u6dfa\u7d05\u8272",
    "Light Yellow": "\u6dfa\u9ec3\u8272",
    "Line height": "\u884c\u9ad8",
    "Link list": "\u9023\u7d50\u6e05\u55ae",
    "Link...": "\u9023\u7d50...",
    "List Properties": "\u6e05\u55ae\u5c6c\u6027",
    "List properties...": "\u6a19\u984c\u5b57\u9ad4\u5c6c\u6027",
    "Loading emojis...": "\u6b63\u5728\u8f09\u5165Emojis...",
    "Loading...": "\u8f09\u5165\u4e2d...",
    "Lower Alpha": "\u5c0f\u5beb\u82f1\u6587\u5b57\u6bcd",
    "Lower Greek": "\u5c0f\u5beb\u5e0c\u81d8\u5b57\u6bcd",
    "Lower Roman": "\u5c0f\u5beb\u7f85\u99ac\u6578\u5b57",
    "Match case": "\u5927\u5c0f\u5beb\u5339\u914d",
    "Mathematical": "\u6578\u5b78",
    "Media poster (Image URL)": "\u5c01\u9762(\u5716\u7247\u4f4d\u5740)",
    "Media...": "\u591a\u5a92\u9ad4...",
    "Medium Blue": "\u4e2d\u85cd\u8272",
    "Medium Gray": "\u4e2d\u7070\u8272",
    "Medium Purple": "\u4e2d\u7d2b\u8272",
    "Merge cells": "\u5408\u4f75\u5132\u5b58\u683c",
    "Middle": "\u7f6e\u4e2d\u5c0d\u9f4a",
    "Midnight Blue": "\u6df1\u85cd\u8272",
    "More...": "\u66f4\u591a...",
    "Name": "\u540d\u7a31",
    "Navy Blue": "\u6d77\u8ecd\u85cd",
    "New document": "\u65b0\u589e\u6587\u4ef6",
    "New window": "\u65b0\u7a97\u53e3",
    "Next": "\u4e0b\u4e00\u500b",
    "No": "\u5426",
    "No alignment": "\u4e0d\u5c0d\u9f4a",
    "No color": "\u7121",
    "Nonbreaking space": "\u4e0d\u5206\u884c\u7a7a\u683c",
    "None": "\u7121",
    "Numbered list": "\u6709\u5e8f\u5217\u8868",
    "OR": "\u6216",
    "Objects": "\u7269\u4ef6",
    "Ok": "\u78ba\u5b9a",
    "Open help dialog": "\u6253\u958b\u5e6b\u52a9\u5c0d\u8a71\u65b9\u584a",
    "Open link": "\u6253\u958b\u9023\u7d50",
    "Open link in...": "\u9023\u7d50\u6253\u958b\u4f4d\u7f6e...",
    "Open popup menu for split buttons": "\u6253\u958b\u5f48\u51fa\u5f0f\u529f\u80fd\u8868\uff0c\u7528\u65bc\u62c6\u5206\u6309\u9215",
    "Orange": "\u6a59\u8272",
    "Outset": "\u5916\u7f6e",
    "Page break": "\u5206\u9801\u7b26",
    "Paragraph": "\u6bb5\u843d",
    "Paste": "\u8cbc\u4e0a",
    "Paste as text": "\u8cbc\u4e0a\u70ba\u6587\u672c",
    "Paste column after": "\u8cbc\u4e0a\u5f8c\u9762\u7684\u5217",
    "Paste column before": "\u8cbc\u4e0a\u6b64\u5217\u524d",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "\u7576\u524d\u70ba\u7d14\u6587\u5b57\u8cbc\u4e0a\u6a21\u5f0f\uff0c\u518d\u6b21\u9ede\u64ca\u53ef\u4ee5\u56de\u5230\u666e\u901a\u8cbc\u4e0a\u6a21\u5f0f\u3002",
    "Paste or type a link": "\u8cbc\u4e0a\u6216\u8f38\u5165\u9023\u7d50",
    "Paste row after": "\u8cbc\u4e0a\u884c\u5230\u4e0b\u65b9",
    "Paste row before": "\u8cbc\u4e0a\u884c\u5230\u4e0a\u65b9",
    "Paste your embed code below:": "\u5c07\u5167\u5d4c\u4ee3\u78bc\u8cbc\u4e0a\u5728\u4e0b\u9762:",
    "People": "\u4eba\u985e",
    "Plugins": "\u5916\u639b\u7a0b\u5f0f",
    "Plugins installed ({0}):": "\u5df2\u5b89\u88dd\u5916\u639b\u7a0b\u5f0f ({0}):",
    "Powered by {0}": "\u7531{0}\u9a45\u52d5",
    "Pre": "\u524d\u8a00",
    "Preferences": "\u9996\u9078\u9805",
    "Preformatted": "\u9810\u5148\u683c\u5f0f\u5316\u7684",
    "Premium plugins:": "\u4ed8\u8cbb\u5916\u639b\u7a0b\u5f0f\uff1a",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "\u9810\u89bd",
    "Previous": "\u4e0a\u4e00\u500b",
    "Print": "\u5217\u5370",
    "Print...": "\u5217\u5370...",
    "Purple": "\u7d2b\u8272",
    "Quotations": "\u5f15\u7528",
    "R": "\u7d05",
    "Range 0 to 255": "\u7bc4\u570d0\u81f3255",
    "Red": "\u7d05\u8272",
    "Red component": "\u7d05\u8272\u90e8\u5206",
    "Redo": "\u91cd\u505a",
    "Remove": "\u79fb\u9664",
    "Remove color": "\u79fb\u9664\u984f\u8272",
    "Remove link": "\u79fb\u9664\u9023\u7d50",
    "Replace": "\u53d6\u4ee3",
    "Replace all": "\u53d6\u4ee3\u5168\u90e8",
    "Replace with": "\u53d6\u4ee3\u70ba",
    "Resize": "\u8abf\u6574\u5927\u5c0f",
    "Restore last draft": "\u6062\u5fa9\u4e0a\u6b21\u7684\u8349\u7a3f",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "\u5bcc\u6587\u672c\u5340\u57df",
    "Rich Text Area. Press ALT-0 for help.": "\u7de8\u8f2f\u5340\u3002\u6309Alt+0\u9375\u6253\u958b\u5e6b\u52a9\u3002",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\u7de8\u8f2f\u5340\u3002\u6309ALT-F9\u6253\u958b\u529f\u80fd\u8868\uff0c\u6309ALT-F10\u6253\u958b\u5de5\u5177\u5217\uff0c\u6309ALT-0\u67e5\u770b\u5e6b\u52a9",
    "Ridge": "\u6d77\u810a\u5ea7",
    "Right": "\u53f3",
    "Right to left": "\u7531\u53f3\u5230\u5de6",
    "Row": "\u884c",
    "Row clipboard actions": "\u884c\u526a\u8cbc\u677f\u64cd\u4f5c",
    "Row group": "\u884c\u7d44",
    "Row header": "\u884c\u982d",
    "Row properties": "\u884c\u5c6c\u6027",
    "Row type": "\u884c\u985e\u578b",
    "Rows": "\u884c\u6578",
    "Save": "\u5132\u5b58",
    "Save (if save plugin activated)": "\u5132\u5b58(\u5982\u679c\u5132\u5b58\u5916\u639b\u7a0b\u5f0f\u5df2\u555f\u52d5)",
    "Scope": "\u7bc4\u570d",
    "Search": "\u641c\u7d22",
    "Select all": "\u5168\u9078",
    "Select...": "\u9078\u64c7...",
    "Selection": "\u9078\u64c7",
    "Shortcut": "\u6377\u5f91",
    "Show blocks": "\u986f\u793a\u5340\u584a\u908a\u6846",
    "Show caption": "\u986f\u793a\u6a19\u984c",
    "Show invisible characters": "\u986f\u793a\u4e0d\u53ef\u898b\u5b57\u5143",
    "Size": "\u5b57\u578b\u5927\u5c0f",
    "Solid": "\u5be6\u7dda",
    "Source": "\u6e90",
    "Source code": "\u539f\u59cb\u7a0b\u5f0f\u78bc",
    "Special Character": "\u7279\u6b8a\u5b57\u5143",
    "Special character...": "\u7279\u6b8a\u5b57\u5143...",
    "Split cell": "\u62c6\u5206\u5132\u5b58\u683c",
    "Square": "\u5be6\u5fc3\u65b9\u584a",
    "Start list at number": "\u4ee5\u6578\u5b57\u958b\u59cb\u6e05\u55ae",
    "Strikethrough": "\u522a\u9664\u7dda",
    "Style": "\u6a23\u5f0f",
    "Subscript": "\u4e0b\u6a19",
    "Superscript": "\u4e0a\u6a19",
    "Switch to or from fullscreen mode": "\u5207\u63db\u5168\u7192\u5e55\u6a21\u5f0f",
    "Symbols": "\u7b26\u865f",
    "System Font": "\u7cfb\u7d71\u5b57\u9ad4",
    "Table": "\u8868\u683c",
    "Table caption": "\u8868\u683c\u6a19\u984c",
    "Table properties": "\u8868\u683c\u5c6c\u6027",
    "Table styles": "\u8868\u683c\u6a23\u5f0f",
    "Template": "\u7bc4\u672c",
    "Templates": "\u7bc4\u672c",
    "Text": "\u6587\u5b57",
    "Text color": "\u6587\u672c\u984f\u8272",
    "Text color {0}": "",
    "Text to display": "\u8981\u986f\u793a\u7684\u6587\u672c",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "\u60a8\u8f38\u5165\u7684 URL \u4f3c\u4e4e\u662f\u4e00\u500b\u96fb\u90f5\u5730\u5740\u3002\u8981\u52a0\u4e0a\u6240\u9700\u7684 mailto:// \u9996\u78bc\u55ce\uff1f",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "\u60a8\u8f38\u5165\u7684 URL \u4f3c\u4e4e\u662f\u4e00\u500b\u5916\u90e8\u9023\u7d50\u3002\u8981\u52a0\u4e0a\u6240\u9700\u7684 http:// \u9996\u78bc\u55ce\uff1f",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "\u60a8\u8f38\u5165\u7684 URL \u4f3c\u4e4e\u662f\u4e00\u500b\u5916\u90e8\u9023\u7d50\u3002\u8981\u52a0\u4e0a\u6240\u9700\u7684 https:// \u9996\u78bc\u55ce\uff1f",
    "Title": "\u6a19\u984c",
    "To open the popup, press Shift+Enter": "\u6309Shitf+Enter\u9375\u6253\u958b\u5c0d\u8a71\u65b9\u584a",
    "Toggle accordion": "",
    "Tools": "\u5de5\u5177",
    "Top": "\u4e0a\u65b9\u5c0d\u9f4a",
    "Travel and Places": "\u65c5\u904a\u548c\u5730\u9ede",
    "Turquoise": "\u9752\u7da0\u8272",
    "Underline": "\u5e95\u7dda",
    "Undo": "\u5fa9\u539f",
    "Upload": "\u4e0a\u8f09",
    "Uploading image": "\u4e0a\u8f09\u5716\u7247",
    "Upper Alpha": "\u5927\u5beb\u82f1\u6587\u5b57\u6bcd",
    "Upper Roman": "\u5927\u5beb\u7f85\u99ac\u6578\u5b57",
    "Url": "\u5730\u5740",
    "User Defined": "\u81ea\u8a02",
    "Valid": "\u6709\u6548",
    "Version": "\u7248\u672c",
    "Vertical align": "\u5782\u76f4\u5c0d\u9f4a",
    "Vertical space": "\u5782\u76f4\u9593\u8ddd",
    "View": "\u67e5\u770b",
    "Visual aids": "\u683c\u7dda",
    "Warn": "\u8b66\u544a",
    "White": "\u767d\u8272",
    "Width": "\u5bec\u5ea6",
    "Word count": "\u5b57\u6578",
    "Words": "\u55ae\u8a5e",
    "Words: {0}": "\u5b57\u6578\uff1a{0}",
    "Yellow": "\u9ec3\u8272",
    "Yes": "\u662f",
    "You are using {0}": "\u4f60\u6b63\u5728\u4f7f\u7528 {0}",
    "You have unsaved changes are you sure you want to navigate away?": "\u4f60\u9084\u6709\u6587\u4ef6\u5c1a\u672a\u5132\u5b58\uff0c\u78ba\u5b9a\u8981\u96e2\u958b\uff1f",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "\u4f60\u7684\u700f\u89bd\u5668\u4e0d\u652f\u63f4\u6253\u958b\u526a\u8cbc\u677f\uff0c\u8acb\u4f7f\u7528Ctrl+X/C/V\u7b49\u5feb\u901f\u9375\u3002",
    "alignment": "\u5c0d\u9f4a",
    "austral sign": "\u6fb3\u5143\u7b26\u865f",
    "cedi sign": "\u585e\u5730\u7b26\u865f",
    "colon sign": "\u5192\u865f",
    "cruzeiro sign": "\u514b\u9b6f\u8cfd\u7f85\u5e63\u7b26\u865f",
    "currency sign": "\u8ca8\u5e63\u7b26\u865f",
    "dollar sign": "\u7f8e\u5143\u7b26\u865f",
    "dong sign": "\u8d8a\u5357\u76fe\u7b26\u865f",
    "drachma sign": "\u5fb7\u62c9\u514b\u99ac\u7b26\u865f",
    "euro-currency sign": "\u6b50\u5143\u7b26\u865f",
    "example": "\u4f8b\u5b50",
    "formatting": "\u683c\u5f0f\u5316",
    "french franc sign": "\u6cd5\u90ce\u7b26\u865f",
    "german penny symbol": "\u5fb7\u570b\u4fbf\u58eb\u7b26\u865f",
    "guarani sign": "\u74dc\u62c9\u5c3c\u7b26\u865f",
    "history": "\u6b77\u53f2",
    "hryvnia sign": "\u683c\u88e1\u592b\u5c3c\u4e9e\u7b26\u865f",
    "indentation": "\u7e2e\u9032",
    "indian rupee sign": "\u5370\u5ea6\u76e7\u6bd4",
    "kip sign": "\u8001\u64be\u57fa\u666e\u7b26\u865f",
    "lira sign": "\u91cc\u62c9\u7b26\u865f",
    "livre tournois sign": "\u88e1\u5f17\u5f17\u723e\u7b26\u865f",
    "manat sign": "\u99ac\u7d0d\u7279\u7b26\u865f",
    "mill sign": "\u5bc6\u723e\u7b26\u865f",
    "naira sign": "\u5948\u62c9\u7b26\u865f",
    "new sheqel sign": "\u65b0\u8b1d\u514b\u723e\u7b26\u865f",
    "nordic mark sign": "\u5317\u6b50\u99ac\u514b",
    "peseta sign": "\u6bd4\u85a9\u659c\u5854\u7b26\u865f",
    "peso sign": "\u6bd4\u7d22\u7b26\u865f",
    "ruble sign": "\u76e7\u5e03\u7b26\u865f",
    "rupee sign": "\u76e7\u6bd4\u7b26\u865f",
    "spesmilo sign": "spesmilo\u7b26\u865f",
    "styles": "\u6a23\u5f0f",
    "tenge sign": "\u5805\u6208\u7b26\u865f",
    "tugrik sign": "\u5716\u683c\u88e1\u514b\u7b26\u865f",
    "turkish lira sign": "\u571f\u8033\u5176\u91cc\u62c9",
    "won sign": "\u97d3\u5143\u7b26\u865f",
    "yen character": "\u65e5\u5143\u5b57\u6a23",
    "yen/yuan character variant one": "\u5143\u5b57\u6a23\uff08\u5927\u5beb\uff09",
    "yuan character": "\u4eba\u6c11\u5e63\u5143\u5b57\u6a23",
    "yuan character, in hong kong and taiwan": "\u5143\u5b57\u6a23\uff08\u6e2f\u81fa\u5730\u5340\uff09",
    "{0} characters": "{0} \u500b\u5b57\u5143",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} \u5b57"
});